const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_numpy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "14.048 7.689 9.405 5.327 4.309 7.89 9.078 10.303 14.048 7.689",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.177 8.771 21.045 11.247 15.994 13.803 11.218 11.386 16.177 8.771",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.678 5.363 27.679 7.89 23.207 10.153 18.328 7.674 22.678 5.363",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.526 4.274 16.023 2 11.57 4.239 16.209 6.597 20.526 4.274",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.006 23.809 17.006 30 22.46 27.258 22.454 21.064 17.006 23.809",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.452 18.903 22.446 12.774 17.006 15.499 17.006 21.63 22.452 18.903",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29 17.754 29 23.969 24.348 26.308 24.345 20.122 29 17.754",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29 15.581 29 9.491 24.339 11.826 24.343 17.967 29 15.581",
    style: {
      fill: "#4dabcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.08,15.5l-3.674-1.861v8.045S6.913,12.05,6.5,11.185a.9.9,0,0,0-.331-.264C5.361,10.5,3,9.29,3,9.29V23.5L6.266,25.26V17.832s4.445,8.607,4.49,8.7a4.026,4.026,0,0,0,.968,1.32c.635.423,3.357,2.073,3.357,2.073Z",
    style: {
      fill: "#4d77cf"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.f8dccf3bb556649a238bc757f32af4cf.svg";
export { ForwardRef as ReactComponent };